import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './NewsBox.module.scss';

interface INewsBoxProps {
	children: ReactNode;
	/**
	 * This props are literal strings because translations keys are also literal strings
	 * todo: refactor this when we refactor translation keys to something meaningful
	 */
	type: 'news';
	title: string;
	date: string;
	place: string;
}

const NewsBox: FC<INewsBoxProps> = ({ children, type, title, date, place }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.newsBox}>
			<div className={styles.newsBoxBackground} />
			<div className={styles.newsBoxInner}>
				<div className={styles.newsBoxType}>{t(type)}</div>
				<div className={styles.newsBoxTitle}>{title}</div>
				<div className={styles.newsBoxInfo}>
					<div>{date}</div>
					<div>{place}</div>
				</div>
				<div className={styles.newsBoxContent}>{children}</div>
			</div>
		</div>
	);
};

export default NewsBox;
